import { get, del, post, put } from "@utils/axios";

const api = "customDashboards";

export const getAllDataReq = (payload) => {
  return get(`${api}?page=1&filters=${payload}`)
};
export const getDashboardDirectivesReq = (payload) => {
  return get(`dashboardDirectives`)
};
export const getDashboardTypes = (payload) => {
  return get(`resources/dashboardType?page=1`);
};

export const createDataReq = (payload) => {
  return post(`${api}?`, payload);
};

export const updateDataReq = (payload) => {
  return put(`${api}/${payload.id}`, payload);
};
export const getDataByIdReq = (id) => {
  return get(`${api}/${id}`);
};

export const deleteDataReq = (id) => {
  return del(`${api}/${id}`);
};

export const getFilterReq = (payload) => {
  return get(`${api}?page=1&filters?company_id=1&fields=page=1&filters=organization_structure_fields_|company;preset_|grade;`)
}